/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private queryParamsSubject = new BehaviorSubject<any>({});
  public queryParams$ = this.queryParamsSubject.asObservable();

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      this.queryParamsSubject.next(params);
    });
  }

  /**
   * Gets the latest query parameters as an object.
   * @returns Current query parameters.
   */
  get queryParams(): any {
    return this.queryParamsSubject.value;
  }
}
